
setTimeout(function() {
    if (!customElements.get('product-filter')) {
        customElements.define('product-filter', class Filter extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                let _this = this;
                this.dataset.urlCollection = location.search;
                this.debouncedOnChange = debounce((event) => {
                    event.preventDefault();
                        this.formSubmit(event);
                }, 200);


                $('select#sort-by').on('change', function(e) {
                    _this.formSubmit(e);
                });

                // $('select#sort-by').on('change', function(e) {
                //
                //     this.updateContent(url,searchParams,sectionId);
                // });

                this.form.addEventListener('submit', this.formSubmit.bind(this));
            };

            formSubmit(evt) {
                evt.preventDefault();
                document.querySelector('[data-loaning]').classList.add('loading');
                const formData = new FormData(evt.target.closest('form'));
                const searchParams = new URLSearchParams(formData).toString();
                const url = this.getAttribute('data-url');
                const urlCollection = this.dataset.urlCollection;
                const sectionId = this.getAttribute('data-section');
                console.log('urlCollection', urlCollection)
                this.updateContent(url,searchParams,sectionId,urlCollection);
            }

            updateContent(url,searchParams,section,urlCollection){
                let _this = this;
                let fetchUrl;
                if(searchParams.includes('sort_by')){
                    if(urlCollection.includes('filter')) {
                        fetchUrl = urlCollection.split('&sort_by')[0] + '&' + searchParams + '&section_id=' + section

                    }else{
                        fetchUrl = url +'?'+searchParams+'&section_id='+section
                    }
                }else{
                    fetchUrl = url+'?'+searchParams+'&section_id='+section
                }
                fetch(fetchUrl).then(function (response) {
                    return response.text();
                }).then(function (responseText) {
                    const doc = new DOMParser().parseFromString(responseText, 'text/html');
                    console.log('_this', _this)
                    const fetchCollectionProducts = doc.querySelector('[data-product-grid]');
                    const collectionProducts = document.querySelector('[data-product-grid]');

                    const fetchCollectionFilter = doc.querySelector('[data-product-filter]');
                    const collectionFilter = document.querySelector('[data-product-filter]');

                    const fetchCollectionSort = doc.querySelector('[data-product-sort]');
                    const collectionSort = document.querySelector('[data-product-sort]');

                    const fetchCollectionCount = doc.querySelector('[data-product-count]');
                    const collectionCount = document.querySelector('[data-product-count]');


                    if(fetchCollectionProducts && collectionProducts){
                        console.log('is FETCH', fetchCollectionProducts);
                        console.log('is DOM', collectionProducts);
                        collectionProducts.innerHTML = fetchCollectionProducts.innerHTML;
                    }

                    if(fetchCollectionSort && collectionSort){
                        collectionSort.innerHTML = fetchCollectionSort.innerHTML;
                    }

                    if(fetchCollectionCount && collectionCount){
                        collectionCount.innerHTML = fetchCollectionCount.innerHTML;
                    }

                    if(fetchCollectionFilter && collectionFilter){
                        // collectionFilter.innerHTML = fetchCollectionFilter.innerHTML;
                        collectionFilter.closest('.filter-panel').querySelector('.js-side-panel-close').click();
                    }

                    if(document.querySelector('[data-url-collection]') !== null){
                        document.querySelector('[data-url-collection]').dataset.urlCollection = fetchUrl.split('&section')[0];
                    }

                    $('select').selectric({
                        disableOnMobile: false,
                        nativeOnMobile: false,
                    });
                    window.history.replaceState({ }, '', fetchUrl.split('&section')[0]);
                    document.querySelector('[data-loaning]').classList.remove('loading');
                }).catch(function (err) {
                    console.error('Something went wrong.', err);
                });
            }
        });
    }
    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}, 500);

